<template>
  <el-form ref="formChild" :model="formChild" class="froms">

    <el-form-item label="账号" :label-width="formLabelWidth">
      <!-- <el-input v-model="formChild.userId" autocomplete="off" placeholder="请输入账号" /> -->
      <!-- <span> {{ formChild.userId }} </span> -->
      {{ childUserAccount + '子账号' }}
    </el-form-item>
    <el-form-item label="手机号" prop="phone" :label-width="formLabelWidth" :rules="[
      { required: true, message: '请输入手机号', trigger: 'blur' },
      { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的11位手机号', trigger: 'blur' }
    ]">
      <el-input v-model="formChild.phone" autocomplete="off" style="width: 280px" />
    </el-form-item>
    <el-form-item label="密码" :label-width="formLabelWidth" prop="passWord"
      :rules="{ required: true, message: '请输入密码', trigger: 'blur' }">
      <el-input v-model="formChild.passWord" autocomplete="off" show-password placeholder="密码" />
      <span class="Cspan">账号创建后将不会再显示密码,请牢记密码</span>

    </el-form-item>
    <el-form-item label="持有人" :label-width="formLabelWidth" prop="useName"
      :rules="{ required: true, message: '请输入持有人', trigger: 'blur' }">
      <el-input v-model="formChild.useName" autocomplete="off" placeholder="输入个人或部门名称" />
    </el-form-item>

    <el-form-item label="过期时间" :label-width="formLabelWidth" prop="endTime"
      :rules="{ required: true, message: '请选择过期时间', trigger: 'change' }">
      <el-date-picker v-model="formChild.endTime" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd" type="date"
        placeholder="选择日期" />
    </el-form-item>
    <el-from-item>
      <span slot="footer" class="dialog-footer">
        <el-button @click="innerVisible = false">取 消</el-button>
        <el-button type="primary" @click="ConfirmAdd('formChild')">确 定</el-button>
      </span>
    </el-from-item>
  </el-form>
</template>

<script>
const base64 = require('js-base64').Base64

export default {

  props: ['childUserAccount'],
  data() {
    return {
      formChild: {
        userId: '',
        passWord: '',
        parentUser: '',
        useName: '',
        endTime: '',
        phone: ""
      },
      formLabelWidth: '120px'
    }
  },
  computed: {
    userId() {
      const a = this.$store.getters.token
      return JSON.parse(base64.decode(a.split('.')[1])).userId
    }
  },
  created() {
    // this.formChild.userId =  JSON.parse(JSON.stringify(this.childUserAccount))
  },
  updated() {

  },
  methods: {
    ConfirmAdd(formChild) {
      this.formChild.userId = this.childUserAccount
      const form = JSON.parse(JSON.stringify(this.formChild))
      this.$refs[formChild].validate((valid) => {
        if (valid && form.userId) {
          this.$emit('ConfirmAdd', form)
        } else {
          this.$message.error('请填写完整信息，或刷新重试')
        }
      })
      // this.$refs.formChild.resetFields()
      setTimeout(() => {
        this.formChild.userId = ''
        this.formChild.passWord = ''
        this.formChild.parentUser = ''
        this.formChild.useName = ''
        this.formChild.endTime = ''
        this.formChild.phone = ''
      }, 500)
      //
    }
  }
}
</script>

<style>
.froms input {
  width: 200px;
}

.Cspan {
  font-size: 13px;
  color: darkgray;
}
</style>
